import { IAgentCustomSkill } from "../../models/AgentSkills/AgentCustomSkill";
import { ICustomSkill } from "../../models/AgentSkills/CustomSkill";
import styles from "./styles.module.css";

interface IProps {
  customSkills: Array<ICustomSkill>;
  agentSkills: Array<IAgentCustomSkill>;
  onChange: (id: number, value: string) => void;
  onRemove: (id: number) => void;
}

/** Skill type ids from the agent_skills table; 2 is the numeric one. */
const TYPE_NUMBER = 2;

/**
 * Custom skills and their per-agent values.
 *
 * Ticking one attaches it; the value goes to the pivot and reaches TaskRouter as a worker
 * attribute keyed by the skill name, which is what a queue's target expression matches on.
 *
 * The row used to hard-code a 200px label beside a 300px input. That needs 510px, and this
 * panel sits in an md={4} column that is usually narrower, so every row overflowed onto the
 * next column. It now shares the row layout in styles.module.css: the label is a fixed column
 * so the inputs line up, and the input takes whatever is left.
 */
const CustomSkills = (props: IProps) => {
  return (
    <div className={styles.Panel}>
      <div className={styles.PanelTitle}>Custom Skills</div>
      <hr className={styles.PanelRule} />
      {props.customSkills.map((skill: ICustomSkill) => {
        const agentSkill = props.agentSkills.find((s) => s.id === skill.id);
        return (
          // Keyed by id, not array index: the list is rendered from what the API returns, and
          // an index key rebinds every input below a change in that list.
          <div key={skill.id} className={styles.Row}>
            <label className={styles.RowLabel} title={skill.key}>
              <input
                type="checkbox"
                checked={agentSkill !== undefined}
                onChange={(e) => {
                  if (!e.target.checked) {
                    props.onRemove(skill.id);
                  } else {
                    props.onChange(skill.id, agentSkill ? agentSkill.value : "");
                  }
                }}
              />
              {skill.key}
            </label>
            <input
              className={styles.Control}
              type={skill.type_id === TYPE_NUMBER ? "number" : "text"}
              id={"skill-" + skill.id}
              aria-label={skill.key + " value"}
              value={agentSkill ? agentSkill.value : ""}
              onChange={(e) => props.onChange(skill.id, e.target.value)}
              disabled={!agentSkill}
            />
          </div>
        );
      })}
    </div>
  );
};

export default CustomSkills;
